import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, filter, map, switchMap, withLatestFrom } from "rxjs/operators";

import { ConsumerService } from "../../../services/api/consumer.service";
import { ConsumerActions } from "../../actions/consumer.actions";
import { ConsumerAdminActions } from "../../actions/consumer-admin.actions";
import { MessagingActions } from "../../actions/messaging.actions";
import { OrderProposalActions } from "../../actions/order-proposal.actions";
import { FailState } from "../../models/fail-state";
import { ActionItemsState } from "../../models/shared/action-items-state";
import { AppState } from "../../reducers";
import { ActionItemsSelectors } from "../../selectors/action-items.selectors";

@Injectable()
export class ConsumerActionItemsEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.actionItems.get),
			withLatestFrom(this.store.select(ActionItemsSelectors.actionItems)),
			switchMap(([, state]) =>
				this.canUseStoreValue(state)
					? of(ConsumerActions.actionItems.getSuccess({ ...state, loading: false }))
					: of(ConsumerActions.actionItems.getApi())
			)
		)
	);

	messageRead = createEffect(() =>
		this.actions.pipe(
			ofType(MessagingActions.conversation.readSuccess),
			filter((action) => action.userType === "CONSUMER"),
			switchMap(() => of(ConsumerActions.actionItems.getApi()))
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(
				ConsumerActions.actionItems.getApi,
				OrderProposalActions.acceptProposal.acceptSuccess,
				OrderProposalActions.cancelProposal.cancelSuccess,
				ConsumerAdminActions.ach.removeSuccess,
				ConsumerAdminActions.creditCard.addSuccess,
				ConsumerAdminActions.creditCard.removeSuccess
			),
			switchMap((action) =>
				this.consumerService.actionItems().pipe(
					map((actionItems) =>
						ConsumerActions.actionItems.getSuccess({ actionItems, loading: false })
					),
					catchError((error) =>
						of(ConsumerActions.actionItems.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerService: ConsumerService,
		private store: Store<AppState>
	) {}

	canUseStoreValue(state: ActionItemsState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
